import React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  Divider,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { CONST, STYLES, SimpleValidators, TokenValidator } from '../../../utils';
import { Orders } from '../../../controllers';

export default function OrderLoader({ open, onClose, onConfirm }) {

  const [loading, isLoading] = React.useState(false);
  const [holder, setHolder] = React.useState('');
  const [files, setFiles] = React.useState([]);

  React.useEffect(() => {
    if(files.length < 1){
      return;
    }

    validateFiles();
  }, [files]);

  const handelCancel = async() => {
    setFiles([]);
    onClose();
  }

  const handleConfirm = async() => {
    var task = [];
    isLoading(true);

    const token = await TokenValidator.GetClientUser();
    for(var x of files){
      if(x.ignore || x.uploaded){
        continue;
      }

      var cycle = new FormData();
      cycle.append('file', x.file);
      const response = await Orders.Send(token, cycle);

      if(response === undefined){
        x.uploaded = false;
        x.status = 'No fetched by Server - Try again';
      }else{
        x.uploaded = response.success;
        x.status = response.message;
      }
      
    };

    isLoading(false);
    onConfirm();
  }

  const handleDrop = async(e) => {
    var received = e.target.files;
    if(Object.keys(received).length < 1){
      return;
    }

    var result = [];
    Object.keys(received).forEach(x => {
      const cycle = {
        file: received[x],
        ignore : false,
        validated : false,
        uploaded : false,
        status : 'Validating'
      };
      result.push(cycle);
    });

    setFiles([...files, ...result]);
    setHolder('');
  }

  const handleRemove = async(index) => {
    setFiles(files.filter((x, i) => i !== index));
  }

  const validateFiles = async() => {
    var task =  [...files];
    var update = false;

    task.forEach(async(x,i) => {
      if(x.validated){
        return;
      }

      update = true;
      x.validated = true;

      const zip = await SimpleValidators.IsZip(x.file.name);
      if(!zip){
        x.ignore = true;
        x.status = 'Not ZIP file'
        return;
      }

      const name = await SimpleValidators.CorrectZipName(x.file.name);
      if(!name){
        x.ignore = true;
        x.status = 'Not correct naming convention'
        return;
      }

      const instances = await SimpleValidators.InstanceCounter(files.map(i => i.file), 'name' , x.file.name);
      if(instances.length > 1){
        if(i > instances[0].index){
          x.ignore = true;
          x.status = 'File already on queue'
          return;
        }
      }

      x.status = 'Ready to Upload'
    });

    if(update){
      setFiles(task);
    }
  }


  return (
    <Dialog open={open} onClose={handelCancel} sx={{minWidth:'65vw'}}>
      <DialogTitle >Order Loader</DialogTitle>
      <Divider />
      <DialogContent>
      <Box
        sx={{
          minWidth: 500,
          padding:2,
          display:'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          border:2,
          borderRadius: 4,
          position:'relative',
          borderColor: CONST.Colors.Primary.Main
        }}
      >
          <Typography
            color='primary'
          >
            Drag one or more files
          </Typography>
          <AddIcon color='primary' />
          <input
            type="file"
            multiple
            onChange={handleDrop}
            value={holder}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              border: "2px solid #1976d2",
              borderRadius: "4px",
              width: "100%",
              height: "100%",
              opacity: 0,
            }}
          />
      </Box>
      <TableContainer
        sx={{
          mt:2,
          maxHeight: '25vh',
        }}
      >
        <Table
            size='small'
        >
            <TableHead>
                <TableRow>
                    <TableCell
                        align='center'
                        sx={{
                          ...STYLES.Table001.HeadersXS,
                          width: '50%',
                          border: 1
                        }}
                    >
                        File
                    </TableCell>
                    <TableCell
                        align='center'
                        sx={{
                          ...STYLES.Table001.HeadersXS,
                          width: '50%',
                          border: 1
                        }}
                    >
                        Status
                    </TableCell>
                    <TableCell
                        align='center'
                        sx={{
                          ...STYLES.Table001.HeadersXS,
                          width: '10%',
                          border: 1
                        }}
                    >
                        Remove
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {files.length > 0 && files.map((row, i) => (
                <TableRow
                    key={i}
                >
                    <TableCell
                      sx={{
                        color: row.ignore ? 'grey' : ''
                      }}
                    >
                        {row.file.name}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: row.ignore ? 'red' : row.uploaded ? 'limegreen' : 'red'
                      }}
                    >
                        {row.status}
                    </TableCell>
                    <TableCell align='center'>
                        <IconButton color='error' onClick={() => handleRemove(i)}>
                          <DeleteForeverIcon />
                        </IconButton>
                    </TableCell>
                </TableRow>
            ))}
            </TableBody>

        </Table>
      </TableContainer>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={() => setFiles([])} variant='outlined'>Clear queue</Button>
        <Button onClick={handelCancel} color='error' variant='contained' >Cancel</Button>
        <Button onClick={handleConfirm} variant='contained' disabled={loading}>Load Orders</Button>
      </DialogActions>
    </Dialog>
  );
}